import { render, staticRenderFns } from "./Configuracoes.vue?vue&type=template&id=d8f254d8&scoped=true&"
import script from "./Configuracoes.vue?vue&type=script&lang=js&"
export * from "./Configuracoes.vue?vue&type=script&lang=js&"
import style0 from "./Configuracoes.vue?vue&type=style&index=0&id=d8f254d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f254d8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8f254d8')) {
      api.createRecord('d8f254d8', component.options)
    } else {
      api.reload('d8f254d8', component.options)
    }
    module.hot.accept("./Configuracoes.vue?vue&type=template&id=d8f254d8&scoped=true&", function () {
      api.rerender('d8f254d8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/configuracoes/Configuracoes.vue"
export default component.exports